(() => {
  const isOptanonAlertClosed = document.cookie.indexOf('OptanonAlertBoxClosed')
  const isNewsletterPopup = localStorage.getItem('newsletter_popup_hidden');
  const newsletterPopup = document.querySelector('#js-newsletter-popup');
  const newsletterClose = document.querySelectorAll('.js-newsletter-popup__close');
  const newsletterPopupDelay = Number(newsletterPopup.dataset.popupDelay);
  const showPopup = () => {
    if(newsletterPopup) {
      if(window.location.href.indexOf('customer_posted') > -1 || window.location.href.indexOf('form_type=customer') > -1) {
        newsletterPopup.classList.remove('is-hidden');
        localStorage.removeItem('newsletter_popup_hidden')
      } else {
        setTimeout(() => {
          newsletterPopup.classList.remove('is-hidden');
          localStorage.removeItem('newsletter_popup_hidden')
        }, newsletterPopupDelay);
      }
    }
  }

  // window.OneTrust.OnConsentChanged(() => {
  //   showPopup();
  // });

  if(isOptanonAlertClosed > -1 && !isNewsletterPopup) {
    showPopup();
  }

  if(newsletterClose) {
    newsletterClose.forEach(close => {
      close.addEventListener('click', e => {
        e.preventDefault();
        newsletterPopup.classList.add('is-hidden');
        localStorage.setItem('newsletter_popup_hidden', true)
      })
    })
  }
})();